import { useEffect } from 'react'

import { IS_PROD_BUILD } from '@src/config/env'

const TRUE_FIT_STORE_KEY = 'qnc'

const TRUE_FIT_OPTIONS = { autoCalculate: true }

declare global {
  interface Window {
    tfcapi?: (...args: any[]) => void
  }
}

const useTrueFit = () => {
  useEffect(() => {
    let initFn: any
    window.tfcapi = initFn =
      window.tfcapi ||
      function () {
        initFn.q = initFn.q || []
        initFn.q.push(arguments)
      }
    try {
      initFn('init', {
        storeKey: TRUE_FIT_STORE_KEY,
        environment: IS_PROD_BUILD ? 'prod' : 'staging',
        ...TRUE_FIT_OPTIONS,
      })
    } catch (e) {
      console.error('useTrueFit init function called incorrectly')
    }

    const scriptTag = document.getElementsByTagName('script')[0]

    const newScriptTag = document.createElement('script')

    newScriptTag.type = 'text/javascript'
    newScriptTag.async = true

    newScriptTag.src =
      'https://' +
      TRUE_FIT_STORE_KEY +
      '-cdn' +
      (IS_PROD_BUILD ? '' : '.staging') +
      '.truefitcorp.com/fitrec/en-us-latest/js/tf-integration.js?storeKey=' +
      TRUE_FIT_STORE_KEY

    scriptTag?.parentNode?.insertBefore(newScriptTag, scriptTag)
  }, [])
}

export { useTrueFit }
